// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_DeleteCategoriaTicketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /tickets/deleteCategoriaTicket
 *
 * Deletes a ticket category by ID.
 */
import { registerContract } from './validate'

export interface Tickets_DeleteCategoriaTicketInput {
id: number
}

registerContract('Tickets_DeleteCategoriaTicketInput', {
  id: { type: 'number',  required: true },
})
